// extracted by mini-css-extract-plugin
module.exports = {"customer-image":"customer-icon_customer-image__17foc","contact-icon":"customer-icon_contact-icon__2fz-R"};